var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "badge",
      class: _vm.getLevelClass,
      style: "font-size:" + _vm.fontSize
    },
    [_vm._v("\n    " + _vm._s(_vm.getDisplayLabel) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }